import { render, staticRenderFns } from "./SectionPickerItem.vue?vue&type=template&id=38e48426&scoped=true&"
import script from "./SectionPickerItem.vue?vue&type=script&lang=js&"
export * from "./SectionPickerItem.vue?vue&type=script&lang=js&"
import style0 from "./SectionPickerItem.vue?vue&type=style&index=0&id=38e48426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e48426",
  null
  
)

export default component.exports